// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3tjRk","text":"SelectPayment_text__1aY37","title":"SelectPayment_title__2Cpni","btn":"SelectPayment_btn__5njFA"};